import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgThermometerWarm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.46071 4.50506C4.90572 4.16884 5.45038 3.99108 6.00806 4.00006C6.28416 4.00451 6.50438 4.23195 6.49994 4.50806C6.49549 4.78416 6.26805 5.00438 5.99194 4.99994C5.65734 4.99454 5.33054 5.1012 5.06353 5.30293C4.79653 5.50467 4.60465 5.7899 4.51842 6.11325C4.4322 6.43659 4.45657 6.77949 4.58768 7.08739C4.71878 7.39529 4.94908 7.6505 5.24194 7.81244C5.4836 7.94606 5.57119 8.25028 5.43756 8.49194C5.30394 8.7336 4.99972 8.82119 4.75806 8.68756C4.26995 8.41768 3.88612 7.99232 3.66761 7.47916C3.44911 6.96599 3.40848 6.3945 3.55219 5.85558C3.6959 5.31667 4.0157 4.84129 4.46071 4.50506Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6 1C6.27614 1 6.5 1.22386 6.5 1.5V2.5C6.5 2.77614 6.27614 3 6 3C5.72386 3 5.5 2.77614 5.5 2.5V1.5C5.5 1.22386 5.72386 1 6 1Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.65355 8.84645C3.84882 9.04171 3.84882 9.35829 3.65355 9.55355L2.95355 10.2536C2.75829 10.4488 2.44171 10.4488 2.24645 10.2536C2.05118 10.0583 2.05118 9.74171 2.24645 9.54645L2.94645 8.84645C3.14171 8.65118 3.45829 8.65118 3.65355 8.84645Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.5 6.5C0.5 6.22386 0.723858 6 1 6H2C2.27614 6 2.5 6.22386 2.5 6.5C2.5 6.77614 2.27614 7 2 7H1C0.723858 7 0.5 6.77614 0.5 6.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M2.24645 2.74645C2.44171 2.55118 2.75829 2.55118 2.95355 2.74645L3.65355 3.44645C3.84882 3.64171 3.84882 3.95829 3.65355 4.15355C3.45829 4.34882 3.14171 4.34882 2.94645 4.15355L2.24645 3.45355C2.05118 3.25829 2.05118 2.94171 2.24645 2.74645Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.5 2C7.5 1.17157 8.17157 0.5 9 0.5C9.82843 0.5 10.5 1.17157 10.5 2V6.99989C11.1065 7.45544 11.5 8.18154 11.5 9C11.5 10.3807 10.3807 11.5 9 11.5C7.61929 11.5 6.5 10.3807 6.5 9C6.5 8.18154 6.89351 7.45544 7.5 6.99989V2Z",
			fill: "currentColor"
		})
	]
});
export default SvgThermometerWarm;
